import { DOWNGRADE_URLS } from './consts';
export const downgradeQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    targetProductId,
    existingSubscriptionId,
    msid
  } = request;
  const response = await httpClient.post(DOWNGRADE_URLS[request.operation], {
    targetProductId,
    subscriptionId: existingSubscriptionId,
    msid
  });
  return response.data;
};
//# sourceMappingURL=downgrade.query.js.map